module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-26.0e3d113c.jpg";